module.exports = __webpack_public_path__ + "static/image/default.ver2_0_2.jpg?9b093000";